var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trac-modal',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('modifier-sets',{attrs:{"product":_vm.product},on:{"update-modifiers":function($event){return _vm.$emit('update-modifiers', $event)},"add-modifier-sets":function($event){return _vm.$emit('add-modifier-sets', $event)}}}),_c('div')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }